import { staffDetailAction } from "../Slice/staff-slice";
export const setStaffId = (payload) => {
  return (dispatch) => {
    console.log(payload);
    dispatch(staffDetailAction.setStaffId({ staffId: payload }));
  };
};
